export const COUPON_CONFIG = {
  EVENT_ID: "5087644490",
  DISCOUNT_PERCENTAGE: 10,
  MIN_PURCHASE_AMOUNT: 200, // OMR
  MAX_DISCOUNT_AMOUNT: 200, // OMR
  VALIDITY_START_DATE: "2026-02-01",
  VALIDITY_END_DATE: "2026-04-05",
  VALIDITY_DAYS: 62,
};
